import { render, staticRenderFns } from "./AuthorizedMenu.vue?vue&type=template&id=288b66e2"
import script from "./AuthorizedMenu.vue?vue&type=script&lang=js"
export * from "./AuthorizedMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports